// components/Badges.jsx
import { STATUS_CFG, SOURCE_CFG, pct } from "../mockData";

export function StatusBadge({ status }) {
  const c = STATUS_CFG[status] || STATUS_CFG.PENDING;
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: 4,
      fontSize: 10, fontWeight: 800, letterSpacing: 0.8,
      textTransform: "uppercase", whiteSpace: "nowrap",
      color: c.color, background: c.bg,
      border: `1.5px solid ${c.border}`,
      borderRadius: 5, padding: "3px 9px",
    }}>
      <span style={{ width: 5, height: 5, borderRadius: "50%", background: c.color, flexShrink: 0 }} />
      {status}
    </span>
  );
}

export function SourceBadge({ source }) {
  const c = SOURCE_CFG[source] || { color: "#64748b", bg: "#f8fafc", border: "#e2e8f0" };
  const labels = { PMS: "PMS", BE: "BE", OTA: "OTA" };
  return (
    <span style={{
      display: "inline-block",
      fontSize: 10, fontWeight: 800, letterSpacing: 0.8,
      color: c.color, background: c.bg,
      border: `1.5px solid ${c.border}`,
      borderRadius: 5, padding: "3px 9px", whiteSpace: "nowrap",
    }}>
      {labels[source] || source}
    </span>
  );
}

export function ConfidenceBadge({ score }) {
  const color = score >= 85 ? "#15803d" : score >= 70 ? "#b45309" : "#b91c1c";
  const bg    = score >= 85 ? "#f0fdf4" : score >= 70 ? "#fffbeb" : "#fef2f2";
  const border= score >= 85 ? "#86efac" : score >= 70 ? "#fde68a" : "#fca5a5";
  return (
    <span style={{
      fontFamily: "'DM Mono', monospace",
      fontSize: 12, fontWeight: 600,
      color, background: bg,
      border: `1.5px solid ${border}`,
      borderRadius: 6, padding: "3px 10px",
      display: "inline-flex", alignItems: "center", gap: 5,
      whiteSpace: "nowrap",
    }}>
      <span style={{ width: 6, height: 6, borderRadius: "50%", background: color, display: "inline-block" }} />
      {score}%
    </span>
  );
}

export function UpliftBadge({ base, rec }) {
  const val = pct(base, rec);
  const up  = Number(val) >= 0;
  return (
    <span style={{
      fontFamily: "'DM Mono', monospace",
      fontSize: 12, fontWeight: 700,
      color:      up ? "#15803d" : "#b91c1c",
      background: up ? "#f0fdf4" : "#fef2f2",
      border:     `1.5px solid ${up ? "#86efac" : "#fca5a5"}`,
      borderRadius: 6, padding: "3px 9px", whiteSpace: "nowrap",
    }}>
      {up ? "▲" : "▼"} {Math.abs(val)}%
    </span>
  );
}

export function FallbackBadge() {
  return (
    <span style={{
      fontSize: 9, fontWeight: 800, letterSpacing: 0.5,
      color: "#b45309", background: "#fffbeb",
      border: "1.5px solid #fde68a",
      borderRadius: 4, padding: "2px 7px",
    }}>
      MASTER RATE
    </span>
  );
}

export function PlanBadge({ code }) {
  return (
    <span style={{
      fontSize: 9, fontWeight: 700, letterSpacing: 0.5,
      color: "#6d28d9", background: "#f5f3ff",
      border: "1px solid #c4b5fd",
      borderRadius: 4, padding: "2px 7px",
    }}>
      {code}
    </span>
  );
}
